module.exports = __webpack_public_path__ + "e7ca54f7b03682fc7ce396bb0b04f80e.eot";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/Roboto-Italic-webfont.eot
// module id = 219
// module chunks = 0